import z from 'zod';
import { QueueItemState } from '@mews-commander/data-access';

export const queryParamsSchema = z.object({
    id: z.string().optional(),
    state: z.nativeEnum(QueueItemState).optional(),
});

export type QueueItemQueryParams = z.infer<typeof queryParamsSchema>;

export enum EnterpriseBuilderProFormStep {
    ExportFrom = 'exportFrom',
    ImportTo = 'importTo',
    ExportSettings = 'exportSettings',
}
